<template>
  <div class="py-4 container-fluid">
    <a :style="search.periode_start == '' ? 'margin-right: 10px; pointer-events: none; cursor: default;' : 'margin-right: 10px;'" style="margin-right: 10px;" :href="apiUrl+'export-excel/payroll?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama='+search.nama+''" target="_BLANK"><argon-button :disabled="search.periode_start == ''" color="primary" size="sm" class="mb-3" variant="gradient"><i class="fa fa-file-excel-o" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
    <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="changeNoteSlipGaji()"><i class="fa fa-cog" style="margin-right: 5px;"></i> Setting Note Slip Gaji</argon-button>
    <div class=" row mb-5">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-2">
                <div class="card-header pb-0">
                  <h6>Data Payroll</h6>
                </div>
              </div>
              <div class="col-5">
                <p style="margin-top: 25px; font-weight: bold; padding-left: 85px;">PERIODE {{ moment(search.periode_start).locale('id').format('D MMMM').toUpperCase() }} - {{ moment(search.periode_end).locale('id').format('D MMMM YYYY').toUpperCase() }}</p>
              </div>
              <div class="col-5 float-right d-flex align-items-center justify-content-end" style="padding-right: 30px;">
                <input
                  type="text"
                  class="form-control"
                  style="width: 220px; margin-right: 30px;"
                  placeholder="Cari nama karyawan..."
                  v-model="search.nama"
                  @input="get()"
                >
                <argon-button
                  style="margin-right: 10px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true" style="margin-right: 5px;"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="sendSlip()"
                  :disabled="onLoadingSendSlip == true || search.periode_start == ''"
                >
                  <span v-if="onLoadingSendSlip"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
                  <span v-else>
                      <span><i class="fa fa-paper-plane fa-sm" style="margin-right: 5px;" aria-hidden="true"></i> Send Slip</span>
                  </span>
                </argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr style="color: white;">
                      <th colspan="13" class="text-uppercase text-xxs font-weight-bolder text-center">Basic Data</th>
                      <th rowspan="2" style="background-color: #BDB76B;" class="text-uppercase text-xxs font-weight-bolder align-middle">Alpa</th>
                      <th rowspan="2" style="background-color: #BDB76B;" class="text-uppercase text-xxs font-weight-bolder align-middle">HK</th>
                      <th rowspan="2" style="background-color: #BDB76B;" class="text-uppercase text-xxs font-weight-bolder align-middle">OT</th>
                      <th rowspan="2" style="background-color: #BDB76B;" class="text-uppercase text-xxs font-weight-bolder align-middle">Lembur</th>
                      <th rowspan="2" style="background-color: #BDB76B;" class="text-uppercase text-xxs font-weight-bolder align-middle">Bonus</th>
                      <th rowspan="2" style="background-color: #BDB76B;" class="text-uppercase text-xxs font-weight-bolder align-middle">Total Gaji</th>
                      <th colspan="14" style="background-color: dimgrey;" class="text-uppercase text-xxs font-weight-bolder text-center">Potongan</th>
                      <th colspan="9" style="background-color: #00CED1;" class="text-uppercase text-xxs font-weight-bolder text-center">Final Salary</th>
                    </tr>
                    <tr style="color: white;">
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder">Nama Karyawan</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Unit</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Status</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Harian</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Bulanan</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Gaji Pokok</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Tj Skill/Jabatan</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Transport</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Makan</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Tj JKK</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Tj JKM</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Tj JKS</th>
                      <th style="background-color: #FF7F50;" class="text-uppercase text-xxs font-weight-bolder ">Insentif</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">Piutang</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">Pinjaman</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">TAX Status</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">PPH21</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">Upah BPJS</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">JHT</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">JKM</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">JKK</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">JP</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">JKS</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">Premi BPJS Kes</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">TOTAL POTONGAN BPJS</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">POTONGAN ABSENSI</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ">TOTAL POTONGAN</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Gaji Diterima</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Sudah Di TF</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Kekurangan</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">No Rek</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">AN Rek</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Bank</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Slip Gaji</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Send Slip Gaji</th>
                      <th style="background-color: #90EE90;" class="text-uppercase text-xxs font-weight-bolder ">Email</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in absenKaryawan.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #87CEEB; cursor: pointer;' : 'cursor: pointer;' ">

                      <!-- =========================================== END BASIC DATA ================================== -->
                      <td style="position: sticky; left: 0; background-color: #ddd;">
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                            <p class="text-xs text-secondary mb-0">{{ row.jabatan}}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p class="text-xs font-weight-bold mb-0">{{ row.unit }}</p>
                        <p class="text-xs font-weight-bold mb-0">{{ row.id_karyawan }}</p>
                      </td>
                      <!-- STATUS -->
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-success">{{ row.status }}</span>
                      </td>
                      <!-- HARIAN -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.harian) }}</span>
                      </td>
                      <!-- BULANAN -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.bulanan) }}</span>
                      </td>
                      <!-- GAJI POKOK -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold" v-if="row.rel_payroll != null">
                          {{ convertRp(Math.round(((row.harian == 0) ? (row.bulanan) : (row.harian * row.total_kerja_count) ))) }}
                        </span>
                      </td>
                      <!-- TJ SKILL -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.tj_jabatan_skill) }}</span>
                      </td>
                      <!-- TRANSPORT -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.transport) }}</span>
                      </td>
                      <!-- U. MAKAN -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp((row.makan)) }}</span>
                      </td>
                      <!-- TJ. JKK -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp((row.tj_jkk)) }}</span>
                      </td>
                      <!-- TJ. JKM -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp((row.tj_jkm)) }}</span>
                      </td>
                      <!-- TJ. JKS -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.tj_jks) }}</span>
                      </td>
                      <!-- INSENTIF -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold" v-if="row.rel_payroll != null">
                          <input style="border: 1px solid transparent; background: transparent; text-align: center;" size="8" v-model="row.rel_payroll.insentif" @change="updatePayroll(row.rel_payroll.id, row.rel_payroll.piutang, row.rel_payroll.pinjaman, row.rel_payroll.kekurangan, row.rel_payroll.status_tf, row.rel_payroll.send_slip, row.rel_payroll.insentif)">
                        </span>
                      </td>
                      <!-- =========================================== END BASIC DATA ================================== -->

                      <!-- =========================================== TOTAL GAJI ================================== -->
                      <!-- TOTAL ALPA -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ row.total_alpa_count }}</span>
                      </td>
                      <!-- TOTAL HK -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ row.total_kerja_count }}</span>
                      </td>
                      <!-- TOTAL OT -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ row.total_ot_count }}</span>
                      </td>
                      <!-- LEMBUR -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(Math.round(row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))) }}</span>
                      </td>
                      <!-- BONUS -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">BONUS</span>
                      </td>
                      <!-- TOTAL GAJI -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold" v-if="row.rel_payroll != null">
                          {{ convertRp(Math.round(Number((
                            ((row.harian == 0) ? (row.bulanan) : (row.harian * row.total_kerja_count) ) )
                            + row.tj_jabatan_skill
                            + row.transport
                            + (row.makan)
                            + (row.tj_jkk)
                            + (row.tj_jkm)
                            + (row.tj_jks)
                            + row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ) )) ) }}
                        </span>
                      </td>
                      <!-- =========================================== END TOTAL GAJI ================================== -->

                      <!-- =========================================== POTONGAN ================================== -->
                      <!-- PIUTANG -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold" v-if="row.rel_payroll != null">
                          <input style="border: 1px solid transparent; background: transparent; text-align: center;" size="8" v-model="row.rel_payroll.piutang" @change="updatePayroll(row.rel_payroll.id, row.rel_payroll.piutang, row.rel_payroll.pinjaman, row.rel_payroll.kekurangan, row.rel_payroll.status_tf, row.rel_payroll.send_slip, row.rel_payroll.insentif)">
                        </span>
                      </td>
                      <!-- PINJAMAN -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold" v-if="row.rel_payroll != null">
                          <input style="border: 1px solid transparent; background: transparent; text-align: center;" size="8" v-model="row.rel_payroll.pinjaman" @change="updatePayroll(row.rel_payroll.id, row.rel_payroll.piutang, row.rel_payroll.pinjaman, row.rel_payroll.kekurangan, row.rel_payroll.status_tf, row.rel_payroll.send_slip, row.rel_payroll.insentif)">
                        </span>
                      </td>
                      <!-- TAX STATUS -->
                      <td class="align-middle text-center">
                        <span class="badge badge-sm bg-gradient-info">{{ row.tax_status }}</span>
                      </td>
                      <!-- PPH21 -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">
                          {{ convertRp(row.pph21) || 0 }}
                        </span>
                      </td>
                      <!-- UPAH BPJS -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.upah_bpjs) }}</span>
                      </td>
                      <!-- JHT -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.jht) }}</span>
                      </td>
                      <!-- JKM -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.jkm) }}</span>
                      </td>
                      <!-- JKK -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.jkk) }}</span>
                      </td>
                      <!-- JP -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.jp) }}</span>
                      </td>
                      <!-- JKS -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.jks) }}</span>
                      </td>
                      <!-- PREMI BPJS KES (value = Tj JKS, ikut mengurangi Gaji Diterima) -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(row.tj_jks) || 0 }}</span>
                      </td>
                      <!-- TOTAL POTONGAN BPJS -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(Number(row.jht + row.jkm + row.jkk + row.jp + row.jks + row.tj_jks)) }}</span>
                      </td>
                      <!-- POTONGAN ABSENSI / KETERLAMBATAN -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(potonganKeterlambatanTotal(row)) }}</span>
                      </td>
                      <!-- TOTAL POTONGAN -->
                      <td class="align-middle text-center">
                        <span v-if="row.rel_payroll != null">
                          <span class="text-black text-xs font-weight-bold">{{ convertRp(Math.round(Number(row.rel_payroll.piutang + row.rel_payroll.pinjaman + row.jht + row.jkm + row.jkk + row.jp + row.jks + row.tj_jks + row.pph21) + potonganKeterlambatanTotal(row))) }}</span>
                        </span>
                      </td>
                      <!-- =========================================== END POTONGAN ================================== -->

                      <!-- =========================================== FINAL SALARY ================================== -->
                      <!-- GAJI DITERIMA -->
                      <td class="align-middle text-center" v-if="row.rel_payroll != null">
                        <span class="text-black text-xs font-weight-bold">{{ convertRp(Math.round(Number(((row.harian == 0) ? (row.bulanan) : (row.harian * row.total_kerja_count) ) + row.tj_jabatan_skill + row.transport + row.makan + row.tj_jkk + row.tj_jkm + row.tj_jks + row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ) + 1) - ( Number(row.rel_payroll.piutang + row.rel_payroll.pinjaman) + Number(row.jht + row.jkm + row.jkk + row.jp + row.jks + row.tj_jks) + row.pph21 + potonganKeterlambatanTotal(row) ) )) }}</span>
                      </td>
                      <!-- STATUS TF -->
                      <td class="align-middle text-center">
                        <span v-if="row.rel_payroll != null">
                          <input type="checkbox" v-model="row.rel_payroll.status_tf" true-value="true" false-value="false" @change="updatePayroll(row.rel_payroll.id, row.rel_payroll.piutang, row.rel_payroll.pinjaman, row.rel_payroll.kekurangan, row.rel_payroll.status_tf, row.rel_payroll.send_slip, row.rel_payroll.insentif)">
                        </span>
                      </td>
                      <!-- KEKURANGAN -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold" v-if="row.rel_payroll != null">
                          <input style="border: 1px solid transparent; background: transparent; text-align: center;" size="8" v-model="row.rel_payroll.kekurangan" @change="updatePayroll(row.rel_payroll.id, row.rel_payroll.piutang, row.rel_payroll.pinjaman, row.rel_payroll.kekurangan, row.rel_payroll.status_tf, row.rel_payroll.send_slip, row.rel_payroll.insentif)">
                        </span>
                      </td>
                      <!-- NO REK -->
                      <td class="align-middle text-center">
                        <span class="text-black text-xs font-weight-bold">{{ row.no_rek }}</span>
                      </td>
                      <!-- AN REK -->
                      <td class="align-middle text-left">
                        <span class="text-black text-xs font-weight-bold">{{ row.an_rek }}</span>
                      </td>
                      <!-- BANK -->
                      <td class="align-middle text-left">
                        <span class="text-black text-xs font-weight-bold">{{ row.bank }}</span>
                      </td>
                      <!-- DETAIL SLIP -->
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-info" style="cursor: pointer;" @click="showSlip(row)">Slip</span>
                      </td>
                      <!-- SEND SLIP -->
                      <td class="align-middle text-center">
                        <span v-if="row.rel_payroll != null">
                          <input type="checkbox" v-model="row.rel_payroll.send_slip" true-value="true" false-value="false" @change="updatePayroll(row.rel_payroll.id, row.rel_payroll.piutang, row.rel_payroll.pinjaman, row.rel_payroll.kekurangan, row.rel_payroll.status_tf, row.rel_payroll.send_slip, row.rel_payroll.insentif)">
                        </span>
                      </td>
                      <!-- EMAIL -->
                      <td class="align-middle text-left">
                        <span class="text-black text-xs font-weight-bold">{{ row.email }}</span>
                      </td>
                      <!-- =========================================== END FINAL SALARY ================================== -->

                    </tr>
                    <!-- <tr>
                      <td colspan="" style="background-color: #F8F8FF; text-align: center;">TOTAL</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalSakitAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalIjinAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalAlpaAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalCutiAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalKerjAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalOTAll }}</td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
      </div>
    </div>

    <!-- TAB CLASSIFICATION BANK -->
    <div class="container-fluid" style="margin-top: 90px;" v-if="search.periode_start">
    <!--   <div
        class="page-header min-height-300"
        style="
          background-image: url('https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
          margin-right: -24px;
          margin-left: -34%;
        "
      >
        <span class="mask bg-gradient-success opacity-6"></span>
      </div> -->
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
         
            <div
              class="mx-auto mt-3 col-lg-12 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                  <li class="nav-item" @click="changeTab('BANK BSI')">
                    <a
                      class="px-0 py-1 mb-0 nav-link active"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="true"
                    >
                      <svg
                        class="text-dark"
                        width="16px"
                        height="16px"
                        viewBox="0 0 42 42"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            transform="translate(-2319.000000, -291.000000)"
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                          >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(603.000000, 0.000000)">
                                <path
                                  class="color-background"
                                  d="M22.7597136,19.3090182 L38.8987031,11.2395234 C39.3926816,10.9925342 39.592906,10.3918611 39.3459167,9.89788265 C39.249157,9.70436312 39.0922432,9.5474453 38.8987261,9.45068056 L20.2741875,0.1378125 L20.2741875,0.1378125 C19.905375,-0.04725 19.469625,-0.04725 19.0995,0.1378125 L3.1011696,8.13815822 C2.60720568,8.38517662 2.40701679,8.98586148 2.6540352,9.4798254 C2.75080129,9.67332903 2.90771305,9.83023153 3.10122239,9.9269862 L21.8652864,19.3090182 C22.1468139,19.4497819 22.4781861,19.4497819 22.7597136,19.3090182 Z"
                                />
                                <path
                                  class="color-background"
                                  d="M23.625,22.429159 L23.625,39.8805372 C23.625,40.4328219 24.0727153,40.8805372 24.625,40.8805372 C24.7802551,40.8805372 24.9333778,40.8443874 25.0722402,40.7749511 L41.2741875,32.673375 L41.2741875,32.673375 C41.719125,32.4515625 42,31.9974375 42,31.5 L42,14.241659 C42,13.6893742 41.5522847,13.241659 41,13.241659 C40.8447549,13.241659 40.6916418,13.2778041 40.5527864,13.3472318 L24.1777864,21.5347318 C23.8390024,21.7041238 23.625,22.0503869 23.625,22.429159 Z"
                                  opacity="0.7"
                                />
                                <path
                                  class="color-background"
                                  d="M20.4472136,21.5347318 L1.4472136,12.0347318 C0.953235098,11.7877425 0.352562058,11.9879669 0.105572809,12.4819454 C0.0361450918,12.6208008 6.47121774e-16,12.7739139 0,12.929159 L0,30.1875 L0,30.1875 C0,30.6849375 0.280875,31.1390625 0.7258125,31.3621875 L19.5528096,40.7750766 C20.0467945,41.0220531 20.6474623,40.8218132 20.8944388,40.3278283 C20.963859,40.1889789 21,40.0358742 21,39.8806379 L21,22.429159 C21,22.0503869 20.7859976,21.7041238 20.4472136,21.5347318 Z"
                                  opacity="0.7"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">BANK BSI</span>
                    </a>
                  </li>
                  <li class="nav-item" @click="changeTab('BANK MANDIRI')">
                    <a
                      class="px-0 py-1 mb-0 nav-link"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <svg
                        class="text-dark"
                        width="16px"
                        height="16px"
                        viewBox="0 0 40 44"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>document</title>
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            transform="translate(-1870.000000, -591.000000)"
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                          >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(154.000000, 300.000000)">
                                <path
                                  class="color-background"
                                  d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z"
                                  opacity="0.603585379"
                                />
                                <path
                                  class="color-background"
                                  d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">BANK MANDIRI</span>
                    </a>
                  </li>
                  <li class="nav-item" @click="changeTab('BANK LAIN')">
                    <a
                      class="px-0 py-1 mb-0 nav-link"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <svg
                        class="text-dark"
                        width="16px"
                        height="16px"
                        viewBox="0 0 40 40"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>settings</title>
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            transform="translate(-2020.000000, -442.000000)"
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                          >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(304.000000, 151.000000)">
                                <polygon
                                  class="color-background"
                                  opacity="0.596981957"
                                  points="18.0883333 15.7316667 11.1783333 8.82166667 13.3333333 6.66666667 6.66666667 0 0 6.66666667 6.66666667 13.3333333 8.82166667 11.1783333 15.315 17.6716667"
                                />
                                <path
                                  class="color-background"
                                  d="M31.5666667,23.2333333 C31.0516667,23.2933333 30.53,23.3333333 30,23.3333333 C29.4916667,23.3333333 28.9866667,23.3033333 28.48,23.245 L22.4116667,30.7433333 L29.9416667,38.2733333 C32.2433333,40.575 35.9733333,40.575 38.275,38.2733333 L38.275,38.2733333 C40.5766667,35.9716667 40.5766667,32.2416667 38.275,29.94 L31.5666667,23.2333333 Z"
                                  opacity="0.596981957"
                                />
                                <path
                                  class="color-background"
                                  d="M33.785,11.285 L28.715,6.215 L34.0616667,0.868333333 C32.82,0.315 31.4483333,0 30,0 C24.4766667,0 20,4.47666667 20,10 C20,10.99 20.1483333,11.9433333 20.4166667,12.8466667 L2.435,27.3966667 C0.95,28.7083333 0.0633333333,30.595 0.00333333333,32.5733333 C-0.0583333333,34.5533333 0.71,36.4916667 2.11,37.89 C3.47,39.2516667 5.27833333,40 7.20166667,40 C9.26666667,40 11.2366667,39.1133333 12.6033333,37.565 L27.1533333,19.5833333 C28.0566667,19.8516667 29.01,20 30,20 C35.5233333,20 40,15.5233333 40,10 C40,8.55166667 39.685,7.18 39.1316667,5.93666667 L33.785,11.285 Z"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">BANK LAIN</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BANK BSI -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'BANK BSI'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p>BANK BSI</p>
                <!-- <argon-button color="success" size="xs" class="ms-auto" @click="approveCuti()"><i class="fa fa-bell fa-sm" aria-hidden="true" style="margin-right: 5px;"></i> Export</argon-button> -->
                <a class="ms-auto" :href="apiUrl+'export-excel/payroll-bank?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama_bank='+tab+''" target="_BLANK"><argon-button :disabled="search.periode_start == ''" color="success" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
              </div>
            </div>
            <div class="card-body">
              <div class="card-body px-0 pt-0 pb-2 ">
                  <div class="table-responsive p-0 scroll">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr style="background-color: #F0F8FF;">
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">NAMA</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">JABATAN</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">GAJI</th>
                          <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ADM BANK</th> -->
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO REKENING</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ATAS NAMA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in tableBankBSI.data" :key="i">
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ i + 1  }}</span>
                          </td>
                          <td class="align-middle text-left text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.nama }} </span>
                          </td>
                          <td class="align-middle text-left text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.jabatan }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">Rp. {{ convertRp(Math.round(Number(
                            ((row.harian == 0) ? (row.bulanan) : (row.harian * row.total_kerja_count) )
                            + row.tj_jabatan_skill
                            + row.transport
                            + (row.makan)
                            + (row.tj_jkk)
                            + (row.tj_jkm)
                            + (row.tj_jks)
                            + row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))
                             -
                            ( Number(row.rel_payroll.piutang + row.rel_payroll.pinjaman)
                            + Number(row.jht + row.jkm + row.jkk + row.jp + row.jks )
                            + row.pph21
                            + potonganKeterlambatanTotal(row)
                            ) )) }} </span>
                          </td>
                          <!-- <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> Rp. 1.000 </span>
                          </td> -->
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.no_rek }} </span>
                          </td>
                          <td class="align-middle text-left">
                            <span class="text-secondary text-xs font-weight-bold">{{ row.an_rek }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center font-weight-bold">TOTAL</td>
                          <td class="text-center font-weight-bold">Rp. {{ convertRp(totalGajiPerBank) }}</td>
                          <!-- <td class="text-center font-weight-bold">Rp. {{ convertRp( 1000 * tableBankBSI.data.length) }}</td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <profile-card />
        </div> -->
      </div>
    </div>

    <!-- BANK MANDIRI -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'BANK MANDIRI'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p>BANK MANDIRI</p>
                <a class="ms-auto" :href="apiUrl+'export-excel/payroll-bank?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama_bank='+tab+''" target="_BLANK"><argon-button :disabled="search.periode_start == ''" color="success" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
              </div>
            </div>
            <div class="card-body">
              <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0 scroll">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr style="background-color: #F0F8FF;">
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">NAMA</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">JABATAN</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">GAJI</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO REKENING</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ATAS NAMA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in tableBankBSI.data" :key="i">
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ i + 1  }}</span>
                          </td>
                          <td class="align-middle text-left text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.nama }} </span>
                          </td>
                          <td class="align-middle text-left text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.jabatan }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">Rp. {{ convertRp(Math.round(Number(
                              ((row.harian == 0) ? (row.bulanan) : (row.harian * row.total_kerja_count) )
                              + row.tj_jabatan_skill
                              + row.transport
                              + (row.makan)
                              + (row.tj_jkk)
                              + (row.tj_jkm)
                              + (row.tj_jks)
                              + row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))
                                - (
                              Number(row.rel_payroll.piutang + row.rel_payroll.pinjaman)
                              + Number(row.jht + row.jkm + row.jkk + row.jp + row.jks )
                              + row.pph21
                              + potonganKeterlambatanTotal(row)
                              ) )) }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.no_rek }} </span>
                          </td>
                          <td class="align-middle text-left">
                            <span class="text-secondary text-xs font-weight-bold">{{ row.an_rek }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center font-weight-bold">TOTAL</td>
                          <td class="text-center font-weight-bold">Rp. {{ convertRp(totalGajiPerBank) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <profile-card />
        </div> -->
      </div>
    </div>

    <!-- BANK LAIN -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'BANK LAIN'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p>BANK LAIN</p>
                <a class="ms-auto" :href="apiUrl+'export-excel/payroll-bank?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama_bank='+tab+''" target="_BLANK"><argon-button :disabled="search.periode_start == ''" color="success" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
              </div>
            </div>
            <div class="card-body">
              <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0 scroll">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr style="background-color: #F0F8FF;">
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">NAMA</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">JABATAN</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">GAJI</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ADM BANK</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">GAJI DITERIMA</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO REKENING</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ATAS NAMA</th>
                          <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">BANK</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in tableBankBSI.data" :key="i">
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ i + 1  }}</span>
                          </td>
                          <td class="align-middle text-left text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.nama }} </span>
                          </td>
                          <td class="align-middle text-left text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.jabatan }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">Rp. {{ convertRp(Math.round(Number(
                              ((row.harian == 0) ? (row.bulanan) : (row.harian * row.total_kerja_count) )
                              + row.tj_jabatan_skill
                              + row.transport
                              + (row.makan)
                              + (row.tj_jkk)
                              + (row.tj_jkm)
                              + (row.tj_jks)
                              + row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))
                                - (
                              Number(row.rel_payroll.piutang + row.rel_payroll.pinjaman)
                              + Number(row.jht + row.jkm + row.jkk + row.jp + row.jks )
                              + row.pph21
                              + potonganKeterlambatanTotal(row)
                              ) )) }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> Rp. 6.500 </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">Rp. {{ convertRp(Math.round(Number(
                              ((row.harian == 0) ? ((row.bulanan / row.rel_payroll.periode_total_hk) * row.total_kerja_count) : (row.harian * row.total_kerja_count) )
                              + row.tj_jabatan_skill
                              + row.transport + (row.makan)
                              + (row.tj_jkk) + (row.tj_jkm) + (row.tj_jks)
                              + row.total_ot_count * (((row.unit == 'Head Quarter') || (row.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))
                                - (
                              Number(row.rel_payroll.piutang + row.rel_payroll.pinjaman)
                              + Number(row.jht + row.jkm + row.jkk + row.jp + row.jks )
                              + row.pph21
                              + potonganKeterlambatanTotal(row))
                               - 6500
                              )) }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.no_rek }} </span>
                          </td>
                          <td class="align-middle text-left">
                            <span class="text-secondary text-xs font-weight-bold">{{ row.an_rek }}</span>
                          </td>
                          <td class="align-middle text-left">
                            <span class="text-secondary text-xs font-weight-bold">{{ row.bank }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center font-weight-bold">TOTAL</td>
                          <td class="text-center font-weight-bold">Rp. {{ convertRp(totalGajiPerBank) }}</td>
                          <td class="text-center font-weight-bold">Rp. {{ convertRp( 6500 * tableBankBSI.data.length) }}</td>
                          <td class="text-center font-weight-bold">Rp. {{ convertRp(totalGajiPerBank - (6500 * tableBankBSI.data.length)) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <profile-card />
        </div> -->
      </div>
    </div>

  </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">Nama <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Nama" v-model="search.nama" required>
        <label for="example-text-input" class="form-control-label mt-3">Periode <span style="color: red;">*</span></label>
        <input type="month" class="form-control" v-model="search.periode" @change="onPeriodeFilterChange()" required>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilter.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL CHANGE NOTE SLIP GAJI ======= -->
  <div class="container">
    <vue-final-modal v-model="formNoteSlipGaji.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formNoteSlipGaji.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formNoteSlipGaji.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">Note Slip Gaji <span style="color: red;">*</span></label>
        <textarea class="form-control" v-model="noteSlipGaji" rows="10"></textarea>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formNoteSlipGaji.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveNoteSlip()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL CETAK SLIP GAJI ======= -->
  <div class="container">
    <vue-final-modal v-model="formSlip.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header (hidden on print) -->
      <div class="row no-print">
        <div class="col-10 float-left">
          <span class="modal__title">SLIP GAJI - {{ moment(search.periode_start).locale('id').format('MMMM YYYY').toUpperCase() }}</span>
        </div>
        <div class="col-2 float-right text-end">
          <argon-button color="warning" size="sm" variant="gradient" @click="printSlip()" style="margin-right: 10px;"><i class="fa fa-print" aria-hidden="true" style="margin-right: 5px;"></i> Print</argon-button>
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSlip.show = false"></i>
        </div>
      </div><hr class="no-print">
      <!-- end header -->

      <div class="print-slip-area">
        <div class="container">
          <div class="container">
            <h6 class="text-center" style="margin-top: 10px;">SLIP GAJI - {{ moment(search.periode_start).locale('id').format('MMMM YYYY').toUpperCase() }}</h6>
            <p class="text-center" style="margin-top: -10px; font-size: 13px;">Periode {{ moment(search.periode_start).locale('id').format('D MMMM') }} - {{ moment(search.periode_end).locale('id').format('D MMMM YYYY') }}</p>
            <hr>
            <div class="row">
              <div class="col-6">
                <p style="margin-top: 10px; font-size: 15px;">ID <span style="margin-left: 70px; margin-right: 20px;">:</span> {{ slip.id_karyawan }}</p>
                <p style="margin-top: -10px; font-size: 15px;">NAMA <span style="margin-left: 41px; margin-right: 20px;">:</span> {{ slip.nama }}</p>
                <p style="margin-top: -10px; font-size: 15px;">JABATAN <span style="margin-left: 23px; margin-right: 20px;">:</span> {{ slip.jabatan }}</p>
                <p style="margin-top: -10px; font-size: 15px;">STATUS <span style="margin-left: 32px; margin-right: 20px;">:</span> {{ slip.status }}</p>
              </div>
              <div class="col-6 text-center">
                <img src="../../assets/img/bck.png" width="80" />
                <p>PT. BUANA CENTRA KARYA</p>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <hr>
                PENERIMAAN
                <hr style="margin-top: 2px;">
                <p style="font-size: 15px;">Gaji Pokok <span style="margin-left: 63px; margin-right: 10px;">:</span>
                  {{ convertRp(Math.round(((slip.harian == 0) ? (slip.bulanan) : (slip.harian * slip.total_kerja_count) ))) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Tj. Jabatan / Skill <span style="margin-left: 23px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.tj_jabatan_skill) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Transport <span style="margin-left: 67PX; margin-right: 10px;">:</span>
                  {{ convertRp(slip.transport) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">U. Makan <span style="margin-left: 70PX; margin-right: 10px;">:</span>
                  {{ convertRp((slip.makan)) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Tj. JKK <span style="margin-left: 93PX; margin-right: 10px;">:</span>
                  {{ convertRp((slip.tj_jkk)) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Tj. JKM <span style="margin-left: 90PX; margin-right: 10px;">:</span>
                  {{ convertRp((slip.tj_jkm)) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Tj. JKS <span style="margin-left: 93PX; margin-right: 10px;">:</span>
                  {{ convertRp((slip.tj_jks)) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Lembur <span style="margin-left: 82PX; margin-right: 10px;">:</span>
                  {{ convertRp(Math.round(slip.total_ot_count * (( (slip.unit == 'Head Quarter') || (slip.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Jam Lembur <span style="margin-left: 52PX; margin-right: 10px;">:</span>
                  {{ convertRp(slip.total_ot_count) }}
                </p>
              </div>
              <div class="col-6">
                <hr>
                POTONGAN
                <hr style="margin-top: 2px;">
                <p style="font-size: 15px;">JHT <span style="margin-left: 105px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.jht) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">JKM <span style="margin-left: 102px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.jkm) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">JKK <span style="margin-left: 106px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.jkk) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">JP <span style="margin-left: 115px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.jp) }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">JKS <span style="margin-left: 107px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.jks) }}
                </p>
                <p style="margin-top: -10px; font-size: 12px;">Premi BPJS Kes <span style="margin-left: 5px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.tj_jks) || 0 }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">PPH21 <span style="margin-left: 85px; margin-right: 10px;">:</span>
                  {{ convertRp(slip.pph21) || 0 }}
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Lainnya <span style="margin-left: 75px; margin-right: 10px;">:</span>
                  <span v-if="slip.rel_payroll != null">
                    {{ convertRp(Number(slip.rel_payroll.piutang) + Number(slip.rel_payroll.pinjaman)) }}
                  </span>
                </p>
                <p style="margin-top: -10px; font-size: 15px;">Absensi / Keterlambatan <span style="margin-left: 10px; margin-right: 10px;">:</span>
                  <span v-if="slip.rel_payroll != null">
                    {{ convertRp(potonganKeterlambatanTotal(slip)) }}
                  </span>
                </p>
                <p style="margin-top: -10px; font-size: 15px;">HK <span style="margin-left: 110px; margin-right: 10px;">:</span>
                  <span v-if="slip.rel_payroll != null">
                    {{ (+slip.total_kerja_count + +slip.total_alpa_count) }} / {{  slip.total_kerja_count }}
                  </span>
                </p>
              </div>
            </div>
            <hr style="margin-top: 0px;">
            <div class="row font-weight-bold">
              <div class="col-6" style="margin-top: -10px;">
                TOTAL <span style="margin-left: 100px; margin-right: 30px;"></span> {{ convertRp(
                  Math.round(Number(((slip.harian == 0) ? (slip.bulanan) : (slip.harian * slip.total_kerja_count) )
                  + slip.tj_jabatan_skill
                  + slip.transport
                  + slip.makan
                  + slip.tj_jkk
                  + slip.tj_jkm
                  + slip.tj_jks
                  + slip.total_ot_count * (( (slip.unit == 'Head Quarter') || (slip.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) )) )) }}
                <hr style="margin-top: 2px;">
              </div>
              <div class="col-6" style="margin-top: -10px;">
                <span v-if="slip.rel_payroll != null">
                  TOTAL <span style="margin-left: 100px; margin-right: 30px;"></span> {{ convertRp(Number(
                    slip.jht
                    + slip.jkm
                    + slip.jkk
                    + slip.jp
                    + slip.jks
                    + slip.tj_jks
                    + slip.pph21
                    + (Number(slip.rel_payroll.piutang) + Number(slip.rel_payroll.pinjaman))
                    + potonganKeterlambatanTotal(slip)) ) }}
                </span>
                <hr style="margin-top: 2px;">
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <span v-if="slip.rel_payroll != null">
                  <p style="margin-top: 30px; font-weight: bold;">THP <span style="margin-left: 65px; "></span> <span style="border-bottom: 3px double;">
                    {{ convertRp(Math.round(
                      Number(((slip.harian == 0) ? (slip.bulanan) : (slip.harian * slip.total_kerja_count) )
                      + slip.tj_jabatan_skill
                      + slip.transport
                      + slip.makan
                      + slip.tj_jkk
                      + slip.tj_jkm
                      + slip.tj_jks
                      + 1
                      + slip.total_ot_count * (( (slip.unit == 'Head Quarter') || (slip.unit == 'Fabrikasi') ) ? 300000 : (1/173*4430254.18) ))
                      -
                      ((Number(slip.rel_payroll.piutang) + Number(slip.rel_payroll.pinjaman))
                      + Number(slip.jht + slip.jkm + slip.jkk + slip.jp + slip.jks + slip.tj_jks)
                      + slip.pph21
                      + potonganKeterlambatanTotal(slip)) )) }}
                  </span></p>
                </span>
              </div>
            </div>
            <p style="margin-left: 58px; margin-top: 70px; margin-bottom: 80px;">Payroll</p>
            <span style="border-bottom: 3px double; margin-left: 35px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <hr style="margin-top: 30px;">
          </div>
        </div>
      </div>
    </vue-final-modal>
   </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import config from '@/configs/config';
var moment = require('moment');
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import dataPayroll from '@/services/dataPayroll.service';
import akun from '@/services/akun.service';
import { periodeToRange } from '@/helpers/periode';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      moment:moment,
      absenKaryawan: {
        data: []
      },
      tableBankBSI: {
        data: []
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      formNoteSlipGaji: {
        add: true,
        title: "Change Note Slip Gaji",
        show: false
      },
      formSlip: {
        show: false
      },
      slip: {},
      noteSlipGaji: '',
      onLoading: false,
      onLoadingSendSlip: false,
      // karyawan: {},
      // totalSakitAll: '',
      // totalIjinAll: '',
      // totalAlpaAll: '',
      // totalCutiAll: '',
      // totalKerjAll: '',
      // totalOTAll: '',
      totalGajiPerBank: '',
      search: {
        nama: '',
        periode: '',
        periode_start: '',
        periode_end: '',
      },
      backgroundRed: null,
      apiUrl :config.apiUrl,
      tab: '',
      role: '',
    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
    this.getRole();
  },
  methods: {
    // row.potongan_keterlambatan comes from the backend (PayrollController@index/
    // @show/@getBank) -- admin-configured rates (Setting Potongan) x attendance
    // data, 0 by default so nothing changes until Admin sets real rates. The
    // configured alpa rate REPLACES the legacy (bulanan / 22) formula once set
    // (not added on top of it), to avoid double-deducting alpa for monthly
    // employees -- same rule DetailSlip.vue uses for the single-employee view.
    potonganAbsensi(row) {
      const baru = row.potongan_keterlambatan ? Number(row.potongan_keterlambatan.potongan_alpa) : 0;
      if (baru) return baru;
      if (!row.rel_payroll) return 0;
      return Math.round(((row.harian == 0) ? ((row.bulanan / 22) * row.total_alpa_count) : 0));
    },
    potonganTelat(row) {
      return row.potongan_keterlambatan ? Number(row.potongan_keterlambatan.potongan_telat) : 0;
    },
    potonganPulangCepat(row) {
      return row.potongan_keterlambatan ? Number(row.potongan_keterlambatan.potongan_pulang_cepat) : 0;
    },
    // Single number for the "POTONGAN ABSENSI" column -- alpa (or the legacy
    // formula) plus telat/pulang-cepat, so this cell always matches what's
    // folded into TOTAL POTONGAN / GAJI DITERIMA below.
    potonganKeterlambatanTotal(row) {
      return this.potonganAbsensi(row) + this.potonganTelat(row) + this.potonganPulangCepat(row);
    },
    get(){
      let context = this; 
      this.onLoading = true;
                    
      Api(context, dataPayroll.index({nama: context.search.nama, periode_start: context.search.periode_start, periode_end: context.search.periode_end,})).onSuccess(function(response) {
          context.absenKaryawan.data = response.data.data.payroll;
          context.search.periode_start = response.data.data.periode_start;
          context.search.periode_end   = response.data.data.periode_end;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.absenKaryawan.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.onLoading = false;
         context.formFilter.show  = false;
      })
      .call()
    },
    getRole(){
      let context = this;     
      context.onLoading = true;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
          if (response.data.data[0].role != 'Admin') {
            context.$router.push({ path: /detail-profile/+response.data.data[0].employee_id})
          }
      }).onError(function(error) {  
      })
      .call() 
    },
    getBank(nama_bank){
      let context = this; 
      this.onLoading = true;
                    
      Api(context, dataPayroll.getBank({nama_bank: nama_bank, periode_start: context.search.periode_start, periode_end: context.search.periode_end,})).onSuccess(function(response) {    
          context.tableBankBSI.data = response.data.data.payroll;
          context.totalGajiPerBank  = response.data.data.totalGaji;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableBankBSI.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.onLoading = false;
         context.formFilter.show  = false;
      })
      .call()
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.search.periode   = this.search.periode_start ? moment(this.search.periode_start).format('YYYY-MM') : '';
    },
    onPeriodeFilterChange() {
      const range = periodeToRange(this.search.periode);
      this.search.periode_start = range.start;
      this.search.periode_end   = range.end;
    },
    updatePayroll(id, piutang, pinjaman, kekurangan, status_tf, send_slip, insentif){
      let api     = null;
      let context = this;

      api = Api(context, dataPayroll.updatePayroll({
          id: id,
          piutang: piutang,
          pinjaman: pinjaman,
          kekurangan: kekurangan,
          status_tf: status_tf,
          send_slip: send_slip,
          insentif: insentif,
      }));
      api.onSuccess(function(response) {
          context.notify('Updated Success', 'success')
      }).onError(function(error) { 
          context.notify('Updated Failed', 'error')
      }).onFinish(function() {  
          context.get();
      })
      .call();
    },
    sendSlip(){
      let context    = this;       
      this.onLoadingSendSlip = true;

      Api(context, dataPayroll.sendSlip({periode_start: context.search.periode_start, periode_end: context.search.periode_end})).onSuccess(function(response) {    
          // context.absenKaryawan.data = response.data;
          context.notify('Send Slip Success', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              // context.table.data = [];
          }
          context.notify('Send Slip Failed', 'error')
      }).onFinish(function() {  
          context.onLoadingSendSlip = false;
          context.get();
      })
      .call()
    },
    saveNoteSlip(id, piutang, pinjaman, kekurangan, status_tf, send_slip){
      let api     = null;
      let context = this;

      api = Api(context, dataPayroll.updateNoteSlip({note: context.noteSlipGaji}));
      api.onSuccess(function(response) {
          context.notify('Updated Success', 'success')
      }).onError(function(error) { 
          context.notify('Updated Failed', 'error')
      }).onFinish(function() {  
      })
      .call();
    },
    changeNoteSlipGaji() {
      let context = this;               
      Api(context, dataPayroll.getNoteSlip()).onSuccess(function(response) {
          context.noteSlipGaji           = response.data.data;
          context.formNoteSlipGaji.show  = true;
          context.formNoteSlipGaji.title = 'Change Note Slip Gaji';       
      })
      .call()        
    },
    setBg(id) {
      this.backgroundRed = id
    },
    showSlip(row) {
      this.slip = row;
      this.formSlip.show = true;
    },
    printSlip() {
      window.print();
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
    },
    changeTab(tab){
      this.tab = tab
      this.getBank(tab);
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          autoClose: 2000,
        }); // ToastOptions
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<!-- Global (unscoped) on purpose -- printing needs to hide everything on the
     page OUTSIDE this component (navbar, sidebar, the rest of the app shell),
     which scoped/::v-deep CSS can't reach. -->
<style>
@media print {
  body * {
    visibility: hidden;
  }
  .print-slip-area, .print-slip-area * {
    visibility: visible;
  }
  .print-slip-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .no-print {
    display: none !important;
  }
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 600px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED; 
}
</style>
